import React from "react";

export default function MaterialFacet({ handleFilterClick, productMaterial }) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productMaterial = sortObject(productMaterial);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("material_facet") &&
    plpFacetLabel.material_facet != ""
      ? plpFacetLabel.material_facet
      : "Material";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productMaterial).map((material, i) => {
          if (material && productMaterial[material] > 0) {
            return (
              <div>
                <span
                  id={`material-filter-${i}`}
                  key={i}
                  data-value={`${material.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("material_facet", e.target.dataset.value)
                  }>
                  {" "}
                  {material} {` (${productMaterial[material]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
